

































import { defineComponent, PropType } from '@vue/composition-api';
import { SMH } from '@/renderer/scripts/smh';

export default defineComponent({
  name: 'HeaderOperation',
  props: {
    loaded: {
      required: true,
      type: Number,
      default: -1,
    },
    selectedNum: {
      required: true,
      type: Number,
      default: -1,
    },
    roleLoading: {
      type: Boolean,
      default: false,
    },
    roleOptions: {
      required: false,
      type: Array as PropType<SMH.Role[]>,
    },
  },
});
